import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import {
  CREATE_EXPENSE_TYPE,
  UPDATE_EXPENSE_TYPE,
} from "../../../Schema/Expense";

const useExpenseTypeForm = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createExpenseType] = useMutation(CREATE_EXPENSE_TYPE, {
    onCompleted: ({ createExpenseType }) => {
      setLoading(false);

      if (createExpenseType?.isSuccess === true) {
        setAlert(true, "success", createExpenseType?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createExpenseType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateExpenseType] = useMutation(UPDATE_EXPENSE_TYPE, {
    onCompleted: ({ updateExpenseType }) => {
      setLoading(false);
      if (updateExpenseType?.isSuccess === true) {
        setAlert(true, "success", updateExpenseType?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateExpenseType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateExpenseType, createExpenseType, loading, setLoading };
};

export default useExpenseTypeForm;
